let commands = {
  trackLink(linkName, internal = false) {
    if (linkName) {
      this.$ga.event(internal ? 'internalPageClick' : 'externalPageClick', 'click', linkName, 1);
    }
  }
};

module.exports = { commands };
